module.exports = __webpack_public_path__ + "img/a9d1ecf.jpg";